<template>
  <div id="app">
    <meta name="referrer" content="no-referrer" />
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
  data() {
    return {};
  }
};
</script>

<style lang="scss">
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: "PingFang SC", "Helvetica Neue", Helvetica, "microsoft yahei",
    arial, STHeiTi, sans-serif;
}
#app {
  font-family: "PingFang SC", "Helvetica Neue", Helvetica, "microsoft yahei",
    arial, STHeiTi, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  // height: 100%;
  color: #232323;
}
img {
  vertical-align: top;
}
img{
object-fit:cover;
font-family: 'object-fit: cover;'
}
ul,
li {
  list-style: none;
}

.pagination {
  margin: 20px 0;
  text-align: right;
}

.crumbs {
  margin: 0 0 15px;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}

.clearfix:after {
  clear: both;
}
.main-box {
  width: 1100px;
  margin: 0 auto;
}
a {
  text-decoration: none;
  &:hover {
    text-decoration: none;
  }
}
// 面包屑
.breadcrumb-wrap {
  margin-top: 80px;
  height: 50px;
  overflow: hidden;
  border-bottom: 1px solid #e5e5e5;
  span {
    font-size: 16px;
    line-height: 50px;
  }
  .breadcrumb-item {
  }
  .icon-arr {
    width: 26px;
    height: 49px;
    display: inline-block;
    background-image: url(~@/assets/img/icon_arr@2x.jpg);
    background-size: 100% auto;
    background-repeat: no-repeat;
    background-position: 0 0;
    vertical-align: top;
  }
}
//内页
.mod-box {
  padding: 50px 0;
  overflow: hidden;
  &:nth-child(2n-1) {
    background-color: #f7f7f7;
  }
  .box-title {
    padding-bottom: 50px;
    h3 {
      font-size: 18px;
      line-height: 24px;
      color: #f29600;
    }
    p {
      font-size: 14px;
      line-height: 16px;
      padding: 15px 0 0;
    }
  }
}
.normal-box {
  padding: 50px 0;
  overflow: hidden;
  .box-title {
    padding-bottom: 50px;
    h3 {
      font-size: 18px;
      line-height: 24px;
      color: #f29600;
    }
    p {
      font-size: 14px;
      line-height: 16px;
      padding: 15px 0 0;
    }
  }
}
//@at-root
.btn-more {
  width: 88px;
  height: 32px;
  background: #fff;
  border: 1px solid #f29600;
  font-size: 14px;
  color: #f29600;
  line-height: 30px;
  display: inline-block;
  text-align: center;
  text-decoration: none;
  &:hover {
    background: #f29600;
    color: #fff;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue